module.exports = __webpack_public_path__ + "static/media/10.306a1ad8.jpg";